import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"
//Modules
import user from "./modules/user"
import processing from "./modules/processing"
import project from "./modules/project"
import uploader from "./modules/uploader"
import payment from "./modules/payment"
import postPayment from "./modules/post-payment"
import mapview from "./modules/mapview"
import flightProvider from "./modules/flight-provider"


const vuexLocal = new VuexPersistence({
  modules: ["user", "processing", "project", "uploader", "payment", "postPayment", "flightProvider"],
  storage: window.localStorage,
})

Vue.use(Vuex)

const plugins = [vuexLocal.plugin]
// if (process.env.NODE_ENV !== "production") {
//   plugins.push(createLogger())
// }

export default new Vuex.Store({
  modules: {
    user,
    processing,
    project,
    uploader,
    payment,
    postPayment,
    mapview,
    flightProvider
  },
  plugins: plugins,
  // strict: process.env.NODE_ENV !== "production",
  strict: false
})
